<template>
  <section class="ctn">
    <header class="header">
      <router-link class="paper-action" to="/users/new"><heim-icon icon="add"></heim-icon><span>{{ $t('new') }}</span></router-link>
    </header>
    <section class="table">
      <heim-table :data="filteredUsers" :columns="['id', 'name', 'email']" cols="8">
        <template slot="colgroup">
          <col class="one">
          <col class="two">
          <col class="three">
          <col class="four">
          <col class="four">
        </template>
        <template slot="thead" slot-scope="props">
          <th class="collapse only-mobile"></th>
          <th class="id sortable" @click="props.sortBy('id')">#<heim-icon :icon="props.sortOrders['id'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="sortable main" @click="props.sortBy('name')">{{ $t('users') }}<heim-icon :icon="props.sortOrders['name'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="mail">{{ $t('email') }}</th>
          <th class="action nb">{{ $t('nbSite') }}</th>
          <th class="action edit"></th>
          <th class="action activity"></th>
          <th class="action details"></th>
        </template>
        <template slot="tbody" slot-scope="{ item, index, show, openDetail, cols }">
          <tr :key="'users-'+index">
            <td class="only-mobile">
							<heim-icon-button
								:class="show(item)?'opened':''"
								class="icon-button"
								@click.native="openDetail(item)">
								<heim-icon icon="chevron-right"></heim-icon>
							</heim-icon-button>
						</td>
            <td class="id" data-title="#">{{item.id}}</td>
            <td data-title="Users">
                <span class="label">{{item.name}}</span>
            </td>
            <td class="mail" data-title="Email">
                <span>{{item.email}}</span>
            </td>
            <td class="nb" data-title="Sites">
                <span>{{item.Sites.length}}</span>
            </td>
            <td class="edit" data-title="Edit">
              <router-link class="paper-action" :to="{ path: `/users/${item.id}/edit` }">
                <span>{{ $t('edit') }}</span><heim-icon class="icon" icon="chevron-right"></heim-icon></router-link>
            </td>
            <td class="activity" data-title="Activity">
              <router-link class="paper-action" :to="{ path: `/users/${item.id}/details` }">
                <heim-icon icon="timeline"></heim-icon><heim-icon class="icon" icon="chevron-right"></heim-icon></router-link>
            </td>
            <td class="details mobile-link"><router-link class="link"  :to="{ path: `/users/${item.id}/details`}"><heim-icon icon="chevron-right"></heim-icon></router-link></td>
          </tr>
          <transition name="slide-fade" :key="'detail-'+index">
						<tr v-if="show(item)" class="detail only-mobile" :data-detail="item.id">
							<td class="detail-row" :colspan="cols">
								<div class="detail-container">
									<div class="row">
										<div class="item">
											<span class="label"></span>
											<div>{{item.email}}</div>
										</div>
										<div class="item">
											<span class="label">{{ $t('nbSite') }}</span>
											<div>{{item.Sites.length}}</div>
										</div>
									</div>
								</div>
							</td>
						</tr>
					</transition>
        </template>
      </heim-table>
    </section>
  </section>
</template>

<script>
import HeimIcon from "@/components/icon/heim-icon.vue";
import HeimIconButton from "@/components/form/button/heim-icon-button.vue";
import HeimTable from "@/components/layout/list/heim-table.vue";
import { mapState } from "vuex";
import fuseMixin from "@/mixins/fuse";
import { dateFilter } from "vue-date-fns";

export default {
  name: "UsersList",
  components: {
    HeimIcon,
    HeimIconButton,
    HeimTable
  },
  mixins: [fuseMixin],
  mounted() {
    this.$store.dispatch("getUsers");
    // we need to setup fuse inside a watcher
    // because otherwise fuse setups itselfs
    // with an empty array (no data has arrived yet)
    this.$watch(
      vm => vm.users,
      val => {
        this.setupUsers();
      }
    );
    this.setupUsers();

    this.$store.dispatch("setTitle", "Users");
  },
  computed: {
    ...mapState(["search"]),
    ...mapState({ users: state => state.usersState.users })
  },
  filters: {
    date: dateFilter
  }
};
</script>

<style scoped>
.disabled {
  color: #8b969c;
}

col.one { width: 8%; }
col.two { width: 30%; }
col.three { width: 35%; }
col.four { width: 20%; }
</style>
